import $ from 'jquery';
import moment from 'moment';

/* Import common part css && scss */
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-fileinput/css/fileinput.min.css';
import 'bootstrap-tagsinput-custom/src/bootstrap-tagsinput.css';
import 'jschr-bootstrap-modal/css/bootstrap-modal-bs3patch.css';
import 'jschr-bootstrap-modal/css/bootstrap-modal.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

window.jQuery = $;
window.$ = $;
global.jQuery = $;
window.moment = moment;

require('bootstrap');

require('../../../../vendor/yiisoft/yii2/assets/yii');
require('../../../../vendor/yiisoft/yii2/assets/yii.validation');
require('../../../../vendor/yiisoft/yii2/assets/yii.activeForm');
require('../../../../vendor/yiisoft/yii2/assets/yii.gridView');
require('../../../../vendor/bower-asset/yii2-pjax/jquery.pjax');

require('lazyloadxt/dist/jquery.lazyloadxt');
require('jschr-bootstrap-modal/js/bootstrap-modalmanager');
require('jschr-bootstrap-modal/js/bootstrap-modal');
//require('jquery-countdown');
require('../plugins/custom-select');
//require('../plugins/custom-alert');
//require('../plugins/chat');
require('../parts-custom/tabsIndicator');
//require('../plugins/i18n/localization');

/* Import common part js */
require('../parts/common.js');

/* Import common part css */
import '../../scss/common.scss';
